import Component from '@glimmer/component';

export default class MwList extends Component {}
